import { Injectable } from '@angular/core';
import { jkAlert } from './jkClass';
import { jkLib } from './jkCommon';
import { jkRestReturn } from './jkInterface';
import { login,LoginService } from './jkUser';

@Injectable({
  providedIn: 'root',
})
export class JkBDbService  {
  public login: LoginService;
  constructor() {
    //super();
    this.login= login;
  }
  sqlSelect: string = '';
  sqlWhere: string = '';
  sqlOrder: string = '';
  async getcmsma(): Promise<any> {
    // let tblcmsma = [];
    const urlParam = 'maintable=' + 'cmsma' + '&item=' + 'V01' + '&param=';
    //let mRet = jkLib.GetDataSet(url, tblcmsma);
    const mRet = await jkLib.doFetch(this.login.hostName, '/valid', urlParam, this.login.token, 'get');
    return mRet[0];
  };
  async callOtherWork(domain: string, wait: boolean, exe: string, progId: string, dbname: string, userid: string,
    userpassword: string, action: string, subAction: string, defaultValue: string, sqlWhere: string): Promise<jkRestReturn> {
    //let ms: string = ''; //
    //ms = encodeURI(ms);
    //debugger;
    const urlParam = 'wait=' + wait + '&exe=' + exe + '&progid=' + progId + '&dbname=' + dbname + '&userid=' + userid +
      '&userpassword=' + userpassword + '&action=' + action + '&subaction=' + subAction + '&defaultvalue=' + defaultValue +
      '&sqlwhere' + sqlWhere;
    const mReturn = await jkLib.doFetch(this.login.hostName, '/callotherwork', urlParam, this.login.token, 'get');
    return mReturn;

  };
  /* 搬到 jkJob
  async jobInsert(domain: string, notify1: string, options: any, progId: string, kind: string): Promise<jkRestReturn> {
    let ms: string = JSON.stringify(options);
    ms = encodeURI(ms);
    //debugger;
    const urlParam = 'date=' + jkLib.nowDate() + '&time=' + jkLib.nowTime4() + '&dbname=' + Login.dbname +
      '&progid=' + progId + '&kind=' + kind + '&userid=' + Login.UserID + '&notify=' + notify1 +
      '&email=' + (Login.EMAIL === undefined ? '' : Login.EMAIL);
    const mReturn = await jkLib.doFetch(Login.hostName, '/job_insert', urlParam, Login.token, 'post', ms);
    return mReturn;

  };*/
  public async download2Storage(xSql: string, itemName: string): Promise<any[]> {
    let data = [];
    const mReturn: jkRestReturn = await this.simpleSqlJkRestReturn(xSql);
    try {
      //data = JSON.parse(mReturn.data);
      data = mReturn.obj;
    } catch (e: any) {
      jkAlert(e.message, 'download2Storage(' + itemName + ') JSON.parse  error');
    };
    localStorage.setItem(itemName, mReturn.data);
    return data;
  };

  async sendRequest(host: string, url: string, urlParam: string, method: string = 'GET',jkRet:jkRestReturn, data: any = {}): Promise<any> {
    //debugger
    let myUrl = url;
    if (urlParam !== '') {
      if (url.indexOf('?') <= 0) {
        myUrl += '?';
      }
    }
    // jkLib.logRequest(method, url, data);

    let body: any = {};
    const head: any = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      //'authorization': jkLib.Login.token
      authorization:  this.login.token
    };
    if (method.toUpperCase() === 'GET') {
      if (data.where) {
        //debugger;
        //head.where = data.where
        if (data.where !== '') {
          myUrl = myUrl + '&where=' + data.where;
        }
      }
      if (data.order) {
        //head.order = data.order;
        if (data.order !== '') {
          myUrl = myUrl + '&order=' + data.order;
        }
      }
    }
    if (method.toUpperCase() === 'PUT') {

      if (data.key) {
        //debugger;
        //head.where = data.where
        //myUrl = myUrl + '&key='+JSON.stringify(data.key)
        head.key = JSON.stringify(data.key);
      }
      //body = data.values;
      body = data;
    }
    if (method.toUpperCase() === 'POST') {
      //body = data.values;
      body = data;
    }
    if (method.toUpperCase() === 'DELETE') {
      //head.where = data.key
      //myUrl = myUrl + '&key=' + JSON.stringify(data.key);
      body = data;
    }

    //const httpOptions = jkLib.fetchOption(head, body, method,  this.login.hostName);
    const httpOptions = jkLib.fetchOption(head, body, method, host);

    let resData: any;
    await fetch(host + myUrl + urlParam, httpOptions)
      .then(jkLib.checkStatus)
      .then((res: any) => res.json())
      //.then((json: any) => result = json)
      .then((json: any) => resData = json)
      .catch((err: any) => {
        jkRet.result = false;
        jkRet.errorLog = err.message || 'fetch error';
        console.error('fetch error:', err);
      });
    if(!resData){
      if (jkRet.result !== false) {
        jkRet.result = false;
        jkRet.errorLog = 'sendRequest return json error!';
      }
      jkAlert(jkRet.errorLog, 'error');
      return [];
    }
    if(!resData.result){
      jkRet.result = false;
      jkRet.errorLog = resData.errorLog;
      jkRet.message = resData.message;
      jkAlert(resData.errorLog,'error');
      return [];
    }
    jkRet.clear();
    jkRet.ok();
    jkRet.log = resData.log;
    jkRet.message = resData.message;
    jkRet.errorLog = resData.errorLog;
    jkRet.data = resData.data;
    //jkRet.mergeLog(resData);
    return resData.obj;
      try {
        //jkRet = JSON.parse(resData);
        let temp = JSON.stringify(resData);
        jkRet = JSON.parse(temp);
      } catch (error: any) {
        alert('httpRequest return json parse error'+error.message);
      }

    if (method.toUpperCase() === 'GET') {
      if (jkRet.obj === undefined) {
        return jkRet;
      } else {
        return jkRet.obj;
      }

    } else
      if (method.toUpperCase() === 'DELETE') {
        //logger.debug('DELETE result:', JSON.stringify(result))
        return jkRet.obj;
      } else {
        if (method.toUpperCase() === 'PUT') {
          //logger.debug('PUT result:', JSON.stringify(result))
          return jkRet.obj;
        } else {
          if (method.toUpperCase() === 'POST') {
            //logger.debug('POST result:', JSON.stringify(result))
            if (!jkRet) {
              return undefined;
            }
            else {
              return jkRet.obj;
            }
          } else {
            // GET return
            //logger.debug('GET rows:', result.rowsAffected)
            return jkRet.obj;
          }
        }
      }
    /*
      .toPromise()
      .then((data: any) => {
        return method === 'GET' ? data.data : data;
      })
      .catch(e => {
        throw e && e.error && e.error.Message;
      }); */
  }
  /*
  sendRequest(url: string, method: string = "GET", data: any[]): any {

      //let httpParams = new HttpParams(data);
      //let httpOptions  = { withCredentials: false, body: httpParams };
      let result;

      switch (method) {
          case "GET":
              result = data; //jkLib.http.get(url, httpOptions);
              console.debug(result);
              break;
          case "PUT":
              result = []; // jkLib.http.put(url, httpParams, httpOptions);
              break;
          case "POST":
              result = []; //jkLib.http.post(url, httpParams, httpOptions);
              break;
          case "DELETE":
              result = []; //jkLib.http.delete(url, httpOptions);
              break;
      }

      return result
          .toPromise()
          .then((data: any) => {
              return method === "GET" ? data.data : data;
          })
          .catch(e => {
              throw e && e.error && e.error.Message;
          });
  }
  */
  getValidateData(e: any, fieldName: string): any {
    if (e.oldData === undefined) {    // 新增
      return e.newData[fieldName];
    }
    else {
      if (e.newData[fieldName] !== undefined) {
        return e.newData[fieldName];
      } else {
        return e.oldData[fieldName];
      }
    }
  };
  editingStart(data: any): number {
    let old = 1;
    try {
      old = data.FLAG;
      data.FLAG += 1;
      data.MODI_DATE = jkLib.nowDate();
      data.MODIFIER =  this.login.UserID;
    } catch (error: any) {
      console.error('editingStart ', error.message);
    }
    return old;
  };
  initNewRow(data: any): boolean {
    try {
      data.FLAG = 1;
      data.CREATE_DATE = jkLib.nowDate();
      data.CREATOR =  this.login.UserID;
      data.CREATE_DATE = jkLib.nowDate();
      data.CREATOR =  this.login.UserID;

    } catch (error: any) {
      console.error('initNewRow ', error.message);
      return false;
    }
    return true; // flag
  };
  updateData(info: any): string {
    info.data.MODI_DATE = info.key.MODI_DATE;
    info.data.MODIFIER = info.key.MODIFIER;
    info.data.FLAG = info.key.FLAG;
    return JSON.stringify(info.data); // 所有已異動過的資料
  };
  /* 搬到 jkOrm
  async transactionSql(mSQLs: string[]): Promise<jkRestReturn> {
    const urlParam = '';
    const mReturn = await jkLib.doFetch( this.login.hostName, '/db/transactionsql', urlParam,  this.login.token, 'post', mSQLs);

    return mReturn;
  };
搬到 jkOrm  async transactionOneSql(mSQL: string): Promise<jkRestReturn> {
    // debugger;
    //let url =  this.login.hostName + "/transactionsql";
    let mReturn: jkRestReturn = new jkRestReturnClass();
    const mSQLS = [];
    mSQLS.push(mSQL);
    mReturn = await this.transactionSql(mSQLS);
    return mReturn;
  }; */
  async simpleQuery(table: string, field: string, where: string, order: string): Promise<jkRestReturn> {
    const url =  this.login.hostName + '/db/simpleQuery';
    const head: any = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Access-Control-Allow-Origin': '*',
      //'authorization': jkLib. this.login.token
      authorization:  this.login.token,
      table: table,
      field: field,
      where: where,
      order: order
    };

    const httpOptions = jkLib.fetchOption(head, '', 'get',  this.login.hostName);

    let ret2: any;
    await fetch(url, httpOptions)
      .then(jkLib.checkStatus)
      .then((res: any) => res.json())
      .then((json: any) => (ret2 = json))
      .catch((err: any) => console.error(err));

    return ret2;
  };
  async simpleSqlJkRestReturn(mSQL: string): Promise<jkRestReturn> {
    const head: any = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'authorization':  this.login.token,
      'sql': mSQL
    }
    const httpOptions = jkLib.fetchOption(head, {}, 'get',  this.login.hostName)
    let url =  this.login.hostName + '/db/simplesqlRestReturn';
    const ret2 = await jkLib.doFetchOpt(url, httpOptions);
    return ret2; //mReturn;
  };
  async simpleSql<T>(mSQL: string): Promise<T> {
    const head: any = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'authorization':  this.login.token
    }
    //const httpOptions = jkLib.fetchOption(head, {}, 'get',  this.login.hostName)
    const httpOptions = jkLib.fetchOption(head, {sql:mSQL}, 'post',  this.login.hostName)
    let url =  this.login.hostName + '/db/simplesql';
    const ret2 = await jkLib.doFetchOpt(url, httpOptions);
    return ret2; //mReturn;
  };

  async simpleSql_get(mSQL: string): Promise<any> {
    const head: any = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'authorization':  this.login.token,
      'sql': mSQL
    }
    const httpOptions = jkLib.fetchOption(head, {}, 'get',  this.login.hostName)
    let url =  this.login.hostName + '/db/simplesql';
    const ret2 = await jkLib.doFetchOpt(url, httpOptions);
    return ret2; //mReturn;
  };

  // detail:'master'單頭 or 'detail' 單身或子單身 date:單據日期.當單頭時不可空白
  async getAutoNo(type: string, table: string, keyFields: string, keyValues: string, date: string): Promise<jkRestReturn> {
    /*
    let url =  this.login.hostName + '/db/autono?table=' + table + '&type=' + type + '&keyFields=' + keyFields + '&keyValues=' +
      keyValues + '&date=' + date;
    // debugger;
    let mReturn: jkRestReturn = new jkRestReturnClass();
    ajax({
      type: 'GET',
      url: url,
      data: {},
      dataType: 'json',
      timeout: 30000,
      cache: false,
      async: false,  //设置同步了~~~~~~~~~
      success: function (returnedData, status) {
        // 成功 status=success returnedData:回傳json object
        // DevExpress.ui.notify("執行成功!", "success", 3000); // 'info'|'warning'|'error'|'success'|'custom'
        mReturn = returnedData;
      },
      error: function (xhr) {
        mReturn.result = false;
        mReturn.message = '錯誤!  狀態 : ' + xhr.status + ' 訊息 : ' + xhr.statusText;
        //DevExpress.ui.notify(mReturn, "error", 3000); // 'info'|'warning'|'error'|'success'|'custom'
      }
    });
    */
    const urlParam = 'table=' + table + '&type=' + type + '&keyFields=' + keyFields + '&keyValues=' + keyValues + '&date=' + date;
    const mReturn = await jkLib.doFetch( this.login.hostName, '/db/autono', urlParam,  this.login.token, 'get');

    return mReturn;
  };

  // detail:'master'單頭 or 'detail' 單身或子單身 date:單據日期.當單頭時不可空白
  async insertDataSet(data: any, type: string, table: string, keyFields: string, keyValues: string, date: string): Promise<jkRestReturn> {
    /*
    let url =  this.login.hostName + '/db/insert?table=' + table + '&type=' + type + '&keyFields=' + keyFields +
    '&keyValues=' + keyValues + '&date=' + date;
    // debugger;
    let mNewData = JSON.stringify(data); // 所有已異動過的資料
    let mReturn: jkRestReturn = new jkRestReturnClass();
    let mdata = encodeURI(mNewData);
    ajax({
      type: 'POST',
      url: url,
      data: mdata,
      dataType: 'json',
      timeout: 30000,
      async: false,  //设置同步了~~~~~~~~~
      success: function (returnedData, status) {
        // 成功 status=success returnedData:回傳json object
        // DevExpress.ui.notify("執行成功!", "success", 3000); // 'info'|'warning'|'error'|'success'|'custom'
        mReturn = returnedData;
      },
      error: function (xhr) {
        mReturn.message = '錯誤!  狀態 : ' + xhr.status + ' 訊息 : ' + xhr.statusText;
        mReturn.result = false;
        jkAlert(mReturn.message, '');
      }
    });
    */
    const urlParam = 'table=' + table + '&type=' + type + '&keyFields=' + keyFields + '&keyValues=' + keyValues + '&date=' + date;
    const mReturn = await jkLib.doFetch( this.login.hostName, '/db/insert', urlParam,  this.login.token, 'post', data);
    return mReturn;
  };
  async freeGet(param: string): Promise<jkRestReturn> {
    /*let url =  this.login.hostName + param;
    // debugger;
    let mReturn: jkRestReturn = new jkRestReturnClass();
    ajax({
      type: 'GET',
      url: url,
      data: {},
      dataType: 'json',
      timeout: 30000,
      cache: false,
      async: false,  //设置同步了~~~~~~~~~
      success: function (returnedData, status) {
        // 成功 status=success returnedData:回傳json object
        // DevExpress.ui.notify("執行成功!", "success", 3000); // 'info'|'warning'|'error'|'success'|'custom'
        mReturn = returnedData;
      },
      error: function (xhr) {
        mReturn.result = false;
        mReturn.message = '錯誤!  狀態 : ' + xhr.status + ' 訊息 : ' + xhr.statusText;
        //DevExpress.ui.notify(mReturn, "error", 3000); // 'info'|'warning'|'error'|'success'|'custom'
      }
    });
    */
    const urlParam = '';
    const mReturn = await jkLib.doFetch( this.login.hostName, param, urlParam,  this.login.token, 'get');
    return mReturn;
  };
  /* 改用 jkOrm.update
  updateDataSet(url: string, mNewData: string): jkRestReturn {
    let mReturn: jkRestReturn = new jkRestReturnClass();
    let mdata = encodeURI(mNewData);
    ajax({
      type: 'POST',
      url: url,
      data: mdata,
      // context: mNewData,
      dataType: 'json', // 希望SERVER回傳資料格式 (xml, json, script, or html)
      // contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      // contentType: "text/plain",
      timeout: 30000,
      cache: false,
      async: false,  //设置同步了~~~~~~~~~
      success: function (returnedData, status) {
        // 成功 status=success returnedData:回傳json object
        // debugger;
        notify('執行成功!', 'success', 3000); // 'info'|'warning'|'error'|'success'|'custom'
        mReturn = returnedData;
      },
      error: function (xhr) {
        mReturn.message = '錯誤!  狀態 : ' + xhr.status + ' 訊息 : ' + xhr.statusText;
        mReturn.result = false;
        jkAlert(mReturn.message, '錯誤');
      }
    });
    return mReturn;
  };
  updateDataSet2(info: any, oldFlag: number, table, keyFields: string): jkRestReturn {
    let keyValues = '';
    let ary = keyFields.split(',');
    for (let i = 0; i < ary.length; i++) {
      if (keyValues === '') {
        keyValues = info.key[ary[i]];
      } else {
        keyValues = keyValues + '||' + info.key[ary[i]];
      };
    }
    let url: string =  this.login.hostName + '/db/update?table=' + table + '&oldflag=' +
    oldFlag + '&keyFields=' + keyFields + '&keyValues=' + keyValues;
    // debugger;
    let mNewData = jkLib.updateData(info); // 所有已異動過的資料
    let mdata = encodeURI(mNewData);
    let mReturn: jkRestReturn = new jkRestReturnClass();
    ajax({
      type: 'POST',
      url: url,
      data: mdata,
      // context: mNewData,
      dataType: 'json', // 希望SERVER回傳資料格式 (xml, json, script, or html)
      // contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      // contentType (default: 'application/x-www-form-urlencoded; charset=UTF-8') multipart/form-data, or text/plain
      // contentType: "text/plain",
      timeout: 30000,
      cache: false,
      async: false,  //设置同步了~~~~~~~~~
      success: function (returnedData, status) {
        // 成功 status=success returnedData:回傳json object
        // debugger;
        notify('執行成功!', 'success', 3000); // 'info'|'warning'|'error'|'success'|'custom'
        mReturn = returnedData;
      },
      error: function (xhr) {
        mReturn.result = false;
        mReturn.message = '錯誤!  狀態 : ' + xhr.status + ' 訊息 : ' + xhr.statusText;
        jkAlert(mReturn.message, '錯誤');
      }
    });
    return mReturn;
  };
  deleteDataSet(url: string, mNewData: any): jkRestReturn {
    let mReturn: jkRestReturn = new jkRestReturnClass();
    ajax({
      type: 'DELETE',
      url: url,
      data: mNewData,
      timeout: 30000,
      success: (returnedData, status) => {
        // 成功 status=success returnedData:回傳json object
        notify('執行成功!', 'success', 3000); // 'info'|'warning'|'error'|'success'|'custom'
        mReturn = returnedData;
      },
      error: (xhr) => {
        mReturn.result = false;
        mReturn.message = '錯誤!  狀態 : ' + xhr.status + ' 訊息 : ' + xhr.statusText;
        jkAlert(mReturn.message, '錯誤');
        // DevExpress.ui.notify(mReturn, "error", 3000); // 'info'|'warning'|'error'|'success'|'custom'
      }
    });
    return mReturn;
  };
  */
  /*
  getDataSet(url2: string, table: Array<any>): jkRestReturn {
      let mReturn: jkRestReturn = new jkRestReturnClass();
      while (table.length > 0) { table.pop(); };

      if (true) {
          const mXHR = ajax({
              type: 'GET',
              url: url2,
              cache: false,
              async: false,  //设置同步了~~~~~~~~~
              dataType: 'json',
              // data: { "method": "GetDataSet", "param": url2 },
              data: {},
              success: (data, status) => {
                  mReturn = data;
                  if (mReturn.result === false) {
                      jkAlert('下載提示:' + 'GetDataSet:' + url2 + '資料不存在', 'error' + mReturn.message);
                  }
                  else {
                      let mRetData: any[];
                      try {
                          mRetData = JSON.parse(mReturn.data);
                      } catch (e: any) {
                          jkAlert(e.message, 'GetDataSet JSON.parse  error');
                      };
                      mRetData.forEach(element => {
                          table.push(element);
                      }
                      );
                  }
              },
              error: function (xhr, textStatus, errorThrown) {
                  mReturn.result = false;
                  mReturn.message = '錯誤!  狀態 : ' + xhr.status + ' 訊息 : ' + xhr.statusText;
                  jkAlert(mReturn.message, '錯誤');
                  // DevExpress.ui.notify(mReturn, "error", 3000); // 'info'|'warning'|'error'|'success'|'custom'
              },
          }); // end ajax

      }
      return mReturn;
  };*/
  async getMainMenu(uid:string,appId:string): Promise<any> {
    ///api/get-mainmenu?userId=JACK&appName=J3S-ION
    const reqUrl = '/api/get-mainmenu';
    //jkLib.reqParam = `userId=${ this.login.userid}&appName=J3S-ION`
    const reqParam = `userId=${uid}&appName=${appId.toUpperCase()}`; // environment.appId
    try {
      const fetchRet = await jkLib.doFetch( this.login.hostName, reqUrl, reqParam,  this.login.token, 'get');
      if (fetchRet.result) {
        return fetchRet.obj;
      } else {
        jkAlert('無法取得個人功能表:' + fetchRet.errorLog);
      }

    } catch (error: any) {
      const errorMsg = error.message + ' /api/get-mainmenu ';
      console.error(errorMsg);
      return undefined;
    }
  }
  /*
  selectMenu(itemData:MainMenu,router: Router) {
    let id = '/' + jkLib.GetBrackets(itemData.name)
    if (id.length > 1) {
      router.navigateByUrl(id);
    }
  }*/

};



